import { create } from 'zustand';

import { toPlayerMessage } from '@/shared/api';
import { isFresh, singleFlight } from '@/shared/lib';

import { fetchDailyActivity } from '../api/activity.api';

import type { DailyActivity } from './types';

interface ActivityState {
  daily: DailyActivity | null;
  isLoading: boolean;
  error: string | null;
  loadedAt: number | null;

  load: (options?: { force?: boolean }) => Promise<void>;
  reset: () => void;
}

export const useActivityStore = create<ActivityState>()((set, get) => ({
  daily: null,
  isLoading: false,
  error: null,
  loadedAt: null,

  load: singleFlight(async (options?: { force?: boolean }): Promise<void> => {
    if (!options?.force && isFresh(get().loadedAt)) return;

    set({ isLoading: true, error: null });
    try {
      set({ daily: await fetchDailyActivity(), loadedAt: Date.now() });
    } catch (error) {
      set({ error: toPlayerMessage(error) });
    } finally {
      set({ isLoading: false });
    }
  }),

  reset: () => {
    set({ daily: null, error: null, loadedAt: null });
  },
}));
